import { useEffect, useState } from 'react';
import { useDesign } from '../../context/DesignContext';
import type { QrType } from '@flashcard/shared';
import { buildQrValue, generateQrDataUrl } from '../../lib/qr';

const QR_TYPES: { value: QrType; label: string }[] = [
  { value: 'website', label: 'Website' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'email', label: 'E-Mail' },
  { value: 'phone', label: 'Telefon' },
  { value: 'google-review', label: 'Google-Bewertung' },
];

export function QrCodeSelector() {
  const { qrCode, setQrCode } = useDesign();
  const [preview, setPreview] = useState<string | null>(null);

  useEffect(() => {
    if (qrCode) {
      generateQrDataUrl(buildQrValue(qrCode.type, qrCode.value))
        .then(setPreview)
        .catch(() => setPreview(null));
    } else {
      setPreview(null);
    }
  }, [qrCode]);

  const type = qrCode?.type ?? 'website';
  const value = qrCode?.value ?? '';

  return (
    <div>
      <div className="form-group">
        <label>QR-Code-Typ</label>
        <select value={type} onChange={(e) => setQrCode({ type: e.target.value as QrType, value, x: 60, y: 35, size: 15 })}>
          {QR_TYPES.map((t) => (
            <option key={t.value} value={t.value}>
              {t.label}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Ziel (URL / Nummer / E-Mail)</label>
        <input
          value={value}
          placeholder={type === 'website' ? 'https://…' : type === 'email' ? 'mail@…' : '…'}
          onChange={(e) => setQrCode({ type, value: e.target.value, x: qrCode?.x ?? 60, y: qrCode?.y ?? 35, size: qrCode?.size ?? 15 })}
        />
      </div>

      {qrCode && (
        <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
          <button className="btn btn-secondary" onClick={() => setQrCode(null)}>
            QR-Code entfernen
          </button>
          {preview && <img src={preview} alt="QR-Vorschau" style={{ width: 72, height: 72, borderRadius: 4 }} />}
        </div>
      )}
    </div>
  );
}
